import apiClient from './base/apiClient'

export interface UpdateCheckResult {
  update_required: boolean
  /** 왜 그렇게 판단했는지 (disabled / up_to_date / below_min / unknown_version …) */
  reason: string
  min_version?: string | null
  /** itms-apps:// 또는 market:// — 웹뷰가 스토어 앱으로 열어준다 */
  store_url?: string
  /** 스토어 앱이 없을 때 쓸 https 주소 */
  store_web_url?: string
}

export const appUpdateApi = {
  /**
   * 앱이 최신인지 서버에 물어본다.
   *
   * 비교를 서버가 하는 이유: 최소 버전이 바뀔 때마다 앱·웹을 다시 내지 않아도
   * 되게 하려고. 여기서는 결과만 받는다.
   */
  check: async (
    platform: 'ios' | 'android',
    version: string | null
  ): Promise<UpdateCheckResult | null> => {
    try {
      const res = await apiClient.get<{ data: UpdateCheckResult }>(
        '/app/update-check',
        {
          params: { platform, version: version ?? '' },
          skipErrorHandler: true,
        } as never
      )
      return res.data?.data ?? null
    } catch {
      // 확인에 실패하면 아무것도 하지 않는다.
      // 서버가 잠깐 안 되는 것 때문에 앱을 못 쓰게 만들면 안 된다.
      return null
    }
  },
}
